import { get } from 'lodash';
import { instance } from './api.service';

const toRange = ([start, end]) => [start.toISOString(), end.toISOString()];

export const getCustomerLicenses = async ({ userId }) => {
  const resp = await instance.post('/customerdashboard/licenses', { userId });
  return get(resp, 'data.licenses', []);
};

export const getCustomerKpis = async ({ userId, range, licenses, orderDef }) => {
  const resp = await instance.post('/customerdashboard/kpis', { userId, range: toRange(range), licenses, orderDef });
  return get(resp, 'data.counts', {});
};

export const getDeliveriesByDay = async ({ userId, range, licenses, orderDef }) => {
  const resp = await instance.post('/customerdashboard/deliveries-by-day', { userId, range: toRange(range), licenses, orderDef });
  return get(resp, 'data.series', []);
};

export const getTopLocations = async ({ userId, range, limit = 10, licenses, orderDef }) => {
  const resp = await instance.post('/customerdashboard/top-locations', { userId, range: toRange(range), limit, licenses, orderDef });
  return get(resp, 'data.rows', []);
};

export const getRecentOrders = async ({ userId, completedLimit = 10, rejectedLimit = 5, licenses, orderDef }) => {
  const resp = await instance.post('/customerdashboard/recent', { userId, completedLimit, rejectedLimit, licenses, orderDef });
  return {
    completed: get(resp, 'data.completed', []),
    rejected: get(resp, 'data.rejected', []),
  };
};

export const getOrdersInRange = async ({ userId, range, statuses, licenses, orderDef }) => {
  const resp = await instance.post('/customerdashboard/orders-in-range', { userId, range: toRange(range), statuses, licenses, orderDef });
  return get(resp, 'data.orders', []);
};

export const getCustomerReturns = async ({ userId, range, licenses, orderDef }) => {
  const resp = await instance.post('/customerdashboard/returns', { userId, range: toRange(range), licenses, orderDef });
  return {
    cashReturns: get(resp, 'data.cashReturns', []),
    rejectionReturns: get(resp, 'data.rejectionReturns', []),
  };
};
